import React, { useMemo } from "react";
import NewOrderItemDisplayType from "@/scenes/OrderManagement/enum/NewOrderItemDisplayType";
import OrderItemDisplayTypeNameMap from "@/scenes/OrderManagement/map/OrderItemDisplayTypeNameMap";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Checkbox, InputNumber, Radio, Tooltip } from "antd";

const NewOrderItemDisplayTooltipMapping = {
    [NewOrderItemDisplayType.GIFT]: "未勾选赠品时，商品列隐藏赠品；特殊情况下，拆分订单仅包含赠品时，仍然显示赠品。",
};

export interface ProductSettingGroupProps {
    selectedDisplayTypes: NewOrderItemDisplayType[];
    picSize: number;
    maxDisplayCount: number;
    onDisplayTypesChange: (types: NewOrderItemDisplayType[]) => void;
    onPicSizeChange: (size: number) => void;
    onMaxDisplayCountChange: (count: number) => void;
}

const ProductSettingGroup: React.FC<ProductSettingGroupProps> = function (props) {
    const {
        selectedDisplayTypes,
        picSize,
        maxDisplayCount,
        onDisplayTypesChange,
        onPicSizeChange,
        onMaxDisplayCountChange,
    } = props;
    const allTypes = useMemo(() => Object.values(NewOrderItemDisplayType), []);
    const typeCount = useMemo(() => allTypes.length, [allTypes]);

    return (
        <div className="ec-product-setting-panel">
            <Checkbox.Group
                className="ec-product-setting-options"
                value={selectedDisplayTypes}
                onChange={(values) => onDisplayTypesChange(values as NewOrderItemDisplayType[])}
            >
                {allTypes.map((type, index) => {
                    const isLast = index === typeCount - 1;
                    const tooltip = NewOrderItemDisplayTooltipMapping[type];

                    return (
                        <div key={type} className="ec-product-setting-option" style={{ marginBottom: isLast ? 0 : 10 }}>
                            <Checkbox value={type}>{OrderItemDisplayTypeNameMap[type]}</Checkbox>
                            {NewOrderItemDisplayType.PIC === type &&
                            selectedDisplayTypes.includes(NewOrderItemDisplayType.PIC) ? (
                                <Radio.Group
                                    onChange={(e) => onPicSizeChange(e.target.value)}
                                    value={picSize}
                                    size="small"
                                >
                                    <Radio.Button value={40}>小</Radio.Button>
                                    <Radio.Button value={56}>中</Radio.Button>
                                    <Radio.Button value={72}>大</Radio.Button>
                                </Radio.Group>
                            ) : null}

                            {tooltip ? (
                                <Tooltip title={tooltip}>
                                    <QuestionCircleOutlined />
                                </Tooltip>
                            ) : null}
                        </div>
                    );
                })}
            </Checkbox.Group>

            <div className="ec-product-setting-max-count">
                <span>商品种类最大展示数量：</span>
                <InputNumber
                    min={0}
                    max={50}
                    value={maxDisplayCount}
                    onChange={onMaxDisplayCountChange}
                    size="small"
                    style={{ width: 50 }}
                />
                <Tooltip title="超过设定数量会隐藏剩余的商品">
                    <QuestionCircleOutlined style={{ marginLeft: 4 }} />
                </Tooltip>
            </div>
        </div>
    );
};

export default ProductSettingGroup;
